export default {
  LISTINGS_FETCH_START: 'LISTINGS_FETCH_START',
  LISTINGS_FETCH_SUCCESS: 'LISTINGS_FETCH_SUCCESS',
  LISTINGS_FETCH_FAILURE: 'LISTINGS_FETCH_FAILURE',
}
